import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = () => {
  const location = useLocation();
  const farmerProfile = localStorage.getItem('farmerProfile');
  const token = localStorage.getItem('auth_token');

  if (!farmerProfile && !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
